import {Enum} from "library-js/class";

const AuthMethod = new Enum('facebook', 'google', 'apple');
export default AuthMethod;
